module.exports = __webpack_public_path__ + "images/default-light-small.svg";